import COOKIES from '~/constants/cookies';
import { useSearchRequestId } from '~/context/srp/InventoryContext';
import BrowserCookies from '~/utilities/BrowserCookies';

export default function useSetSearchRequestIdCookie() {
  const searchRequestId = useSearchRequestId();

  return () => {
    BrowserCookies.set(COOKIES.searchRequestId, searchRequestId);
  };
}
